<mat-dialog-content>
  <lemon-dialog-header [naytaSuljeRuksi]="false"> Tositteita ladataan </lemon-dialog-header>

  <div style="padding-left: 3em; padding-right: 3em">
    @if (!commonError()) {
      <ul>
        <li>Lasketaan tositteiden määrää ja haetaan metatietoja...</li>
        @if (tiedostojaYhteensa()) {
          <li>Ladataan tositteita koneelle: {{ tiedostojaLadattu() }} / {{ tiedostojaYhteensa() }} valmiina</li>
        }
        @if (tiedostojaYhteensa() && tiedostojaYhteensa() == tiedostojaLadattu()) {
          <li>Luodaan zip-tiedostoa...</li>
        }
      </ul>
    }
    @if (commonError()) {
      <div class="error-text">Tositteiden lataamisen aikana tapahtui virhe. Virhe on tallennettu. Ole hyvä ja ota yhteys ylläpitoon.</div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  @if (commonError()) {
    <app-primary-button actionId="Yhteisömyyntilaskujen lataamisessa tapahtui virhe" mat-dialog-close>OK</app-primary-button>
  }
</mat-dialog-actions>
